@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

// CAROUSEL ARROWS COLORS
.slick-prev:before,
.slick-next:before {
  color: black !important;
}

html {
  background-color: #f5f7f8;
}

a {
  all: unset;
  color: inherit !important;
  &:visited {
    all: unset;
    color: inherit !important;
  }
}

body {
  font-family: 'Roboto';
}

* {
  box-sizing: border-box;
  font-family: 'Roboto';
}

#menu-countryId,
#menu-provinceId {
  max-height: 250px;
}

.MuiAutocomplete-root {
  .MuiButtonBase-root {
    margin-right: 0.25rem !important;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  appearance: textfield;
}

a {
  text-decoration: unset;
}
